import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { Box } from '@hover/blueprint';
import ReadyToSeeContent from './ReadyToSeeContent';

const ReadyToSeeTabletAndDesktop: React.FC = () => (
  <Box
    d={{ base: 'none', tablet: 'flex' }}
    position="relative"
    borderRadius="8px"
    overflow="hidden"
    shadow="distance300"
  >
    <Box d={{ base: 'none', desktop: 'block' }}>
      <StaticImage
        quality={100}
        placeholder="blurred"
        style={{ minHeight: '520px' }}
        alt="home page ready to see"
        src="../../../assets/images/home_page_ready_to_see.png"
      />
    </Box>
    <Box d={{ base: 'none', tablet: 'block', desktop: 'none' }} maxH="520px">
      <StaticImage
        quality={100}
        placeholder="blurred"
        objectPosition="right bottom"
        style={{ width: '100%', maxHeight: 520 }}
        alt="home page ready to see"
        src="../../../assets/images/home_page_ready_to_see_tablet.png"
      />
    </Box>
    <Box
      position="absolute"
      top="103px"
      left={{ tablet: '93px', desktop: '103px' }}
    >
      <ReadyToSeeContent />
    </Box>
  </Box>
);

export default ReadyToSeeTabletAndDesktop;
